module.exports = __webpack_public_path__ + "img/bg.7a9ac327.png";